// Main operating currencies of the network
export const CURRENCIES = [
  { code: "EUR", symbol: "€", name: "Euro", name_es: "Euro", name_ar: "يورو" },
  { code: "USD", symbol: "$", name: "US Dollar", name_es: "Dólar", name_ar: "دولار أمريكي" },
  { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar", name_es: "Dinar iraquí", name_ar: "دينار عراقي" },
  { code: "SYP", symbol: "ل.س", name: "Syrian Pound", name_es: "Libra siria", name_ar: "ليرة سورية" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan (RMB)", name_es: "Yuan (RMB)", name_ar: "يوان صيني" },
];

export const CURRENCY_CODES = CURRENCIES.map((c) => c.code);

export const CURRENCY_SYMBOLS = {
  ...CURRENCIES.reduce((acc, c) => ({ ...acc, [c.code]: c.symbol }), {}),
  MXN: "MX$",
  GBP: "£",
  JPY: "¥",
  AED: "د.إ",
  SAR: "﷼",
};

export function currencyName(code, lang = "es") {
  const c = CURRENCIES.find((x) => x.code === code);
  if (!c) return code;
  if (lang === "ar") return c.name_ar;
  if (lang === "en") return c.name;
  return c.name_es;
}

export function fmtMoney(amount, currency = "EUR") {
  const s = CURRENCY_SYMBOLS[currency] || currency || "";
  const decimals = currency === "IQD" || currency === "SYP" ? 0 : 2;
  const n = Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return `${s} ${n}`;
}
